import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function liqa(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@liqa/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@liqa/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@liqa/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@liqa/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@liqa/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@liqa/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}